export const contractorDetailsRoutes = [
  {
    path: ':reference_number',
    name: 'contractor-details',
    component: () => import(/* webpackChunkName: "contractor-details" */ './ContractorDetails.vue')
  }
];
